import moment from "moment";

const API_HOST = process.env.REACT_APP_API_HOST_URL;

const exportDailyStockoutSummary = async (parameters) => {
    let response = await fetch(
        `${API_HOST}/distributor/admin/export/v1/daily-stockout-summary?token=${parameters.token}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                node_uuids: parameters.node_uuids,
                country: parameters.country,
                product_uuids: parameters.product_uuids,
                start_date: parameters.start_date,
                end_date: parameters.end_date,
            }),
        }
    );

    let blob = await response.blob();

    saveFile(blob);
};

const saveFile = async (blob) => {
    const a = document.createElement("a");
    const date = moment().format("YYYYMMDD");
    a.download = `daily_stockout_summary_${date}.csv`;
    a.href = URL.createObjectURL(blob);
    a.addEventListener("click", (e) => {
        setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
    });
    a.click();
};

export default exportDailyStockoutSummary;
